var map = {
	"./IMG_0823.JPG": 6421,
	"./IMG_0824.JPG": 9518,
	"./IMG_0825.JPG": 9982,
	"./IMG_0826.JPG": 139,
	"./IMG_0827.JPG": 67,
	"./IMG_0828.JPG": 8366,
	"./IMG_0829.JPG": 3812,
	"./IMG_0830.JPG": 4666,
	"./IMG_0831.JPG": 4206,
	"./IMG_0832.JPG": 5073,
	"./IMG_0833.JPG": 666,
	"./IMG_0834.JPG": 8419,
	"./IMG_0835.JPG": 9960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4804;